import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation User_userCourseDeleteUser($coursesId: ID!, $userId: ID!) {
    User_userCourseDeleteUser(coursesId: $coursesId, userId: $userId) {
      status
    }
  }
`;

const UserCourseDeleteUser = async (courseId, userId) =>
  graphql(mutation, {
    coursesId: courseId,
    userId,
  }).then(
    // eslint-disable-next-line camelcase
    ({ User_userCourseDeleteUser }) => User_userCourseDeleteUser
  );

export default UserCourseDeleteUser;
